import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { selectToken } from './tokenSelector.js';
import toRgbColor from './toRgbColor.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var State = /*#__PURE__*/function (State) {
  State["Pressed"] = ":active";
  State["Focused"] = ":focus";
  State["FocusedVisible"] = ":focus-visible";
  State["FocusedWithin"] = ":focus-within";
  State["Hover"] = ":hover";
  return State;
}({});
var ClassName = /*#__PURE__*/function (ClassName) {
  ClassName["Active"] = "ads-active";
  return ClassName;
}({});
var POINTER_HOVER_SELECTOR = '@media(hover: hover) and (pointer: fine)';
var getInteractiveColor = function getInteractiveColor(theme, interactive) {
  try {
    if (!interactive) return undefined;
    var interactiveColorToken = selectToken(theme.text, interactive);
    var textPrimaryInteractiveToken = selectToken(theme.text, 'product.primary');
    var textNeutral4Token = selectToken(theme.text, 'base.inverted');
    if (!interactiveColorToken || !textPrimaryInteractiveToken || !textNeutral4Token) return undefined;
    var color = toRgbColor(interactiveColorToken);
    var colorRgb = "".concat(color.red, ", ").concat(color.green, ", ").concat(color.blue);
    return {
      colorRgb: colorRgb,
      textPrimaryInteractiveToken: textPrimaryInteractiveToken,
      textNeutral4Token: textNeutral4Token
    };
  } catch (error) {
    return undefined;
  }
};
var getAfterSelectorBackgroundContent = function getAfterSelectorBackgroundContent() {
  return {
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      transition: 'background 0.2s ease-in-out, border-color .2s ease-in-out',
      userSelect: 'none'
    }
  };
};
var interactiveState = function interactiveState(theme, interactive) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'relative';
  var interactiveColor = getInteractiveColor(theme, interactive);
  if (!interactiveColor) return {};
  var colorStyle = {
    fill: "rgb(".concat(interactiveColor.colorRgb, ")"),
    color: "rgb(".concat(interactiveColor.colorRgb, ")")
  };
  return _objectSpread(_objectSpread(_defineProperty(_defineProperty({
    '-webkit-tap-highlight-color': 'transparent',
    userSelect: 'none',
    transition: 'background-color, outline-color 0.2s ease-in-out, border-color .2s ease-in-out',
    position: position,
    overflow: 'hidden',
    outlineColor: 'transparent'
  }, "&:focus-visible,&:active,&.".concat(ClassName.Active), {
    color: "rgb(".concat(interactiveColor.colorRgb, ")"),
    borderColor: "rgb(".concat(interactiveColor.colorRgb, ")"),
    '*:not(.ads-non-interactive)': _objectSpread({}, colorStyle)
  }), "".concat(POINTER_HOVER_SELECTOR), {
    '&:hover': {
      color: "rgb(".concat(interactiveColor.colorRgb, ")"),
      borderColor: "rgb(".concat(interactiveColor.colorRgb, ")"),
      '*:not(.ads-non-interactive)': _objectSpread({}, colorStyle)
    },
    '&:hover:after': {
      background: "rgba(".concat(interactiveColor.colorRgb, ", 0.08)")
    }
  }), getAfterSelectorBackgroundContent()), {}, _defineProperty({
    '&:focus-visible': {
      '&:after': {
        background: "rgba(".concat(interactiveColor.colorRgb, ", 0.12)")
      },
      // TODO: ADSWEB-729 Token for outline width
      boxShadow: "0 0 0 2px ".concat(interactiveColor.textNeutral4Token, ", 0 0 0 4px ").concat(interactiveColor.textPrimaryInteractiveToken)
    }
  }, "&:active,&.".concat(ClassName.Active), {
    '&:after': {
      background: "rgba(".concat(interactiveColor.colorRgb, ", 0.16)")
    }
  }));
};

// Class to be set on the children of interactive element
var INTERACTIVE_WITHIN_CLASS = 'ads-interactive-within';
var interactiveWithinState = function interactiveWithinState(theme, interactive) {
  var interactiveColor = getInteractiveColor(theme, interactive);
  if (!interactiveColor) return {};
  return _defineProperty({}, "&:focus-visible .".concat(INTERACTIVE_WITHIN_CLASS), {
    '&:after': {
      background: "rgba(".concat(interactiveColor.colorRgb, ", 0.12)")
    },
    // TODO: ADSWEB-729 Token for outline width
    boxShadow: "0 0 0 2px ".concat(interactiveColor.textNeutral4Token, ", 0 0 0 4px ").concat(interactiveColor.textPrimaryInteractiveToken)
  });
};

export { ClassName, INTERACTIVE_WITHIN_CLASS, POINTER_HOVER_SELECTOR, State, getAfterSelectorBackgroundContent, getInteractiveColor, interactiveState, interactiveWithinState };
//# sourceMappingURL=interactiveState.js.map
